import { useState, useEffect } from 'react';

export const useLockedManualAlert = isLocked => {
  const [showLockedManualAlert, setShowLockedManualAlert] = useState(false);

  function closeLockedManualAlert() {
    setShowLockedManualAlert(false);
  }

  useEffect(() => {
    setShowLockedManualAlert(isLocked);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLocked]);

  return {
    showLockedManualAlert,
    closeLockedManualAlert
  };
};
